import React from "react";
import {
  PROJECT_USER_ROLE_COLORS,
  PROJECT_USER_ROLE_NAMES,
  PROJECT_USER_ROLES
} from "../constants/projectUser";
import { convertListToString } from "../lib/convertListToString";
import Badge from "../components/badge";

const getRolesArray = (roles = []) => {
  let rolesNames = [];
  Object.keys(PROJECT_USER_ROLES).forEach(roleKey => {
    if (roles.includes(PROJECT_USER_ROLES[roleKey])) {
      rolesNames.push({
        name: PROJECT_USER_ROLE_NAMES[roleKey].name,
        type: roleKey
      });
    }
  });
  return rolesNames;
};
export const getRoles = (roles = [], connector, lastConnector) => {
  return convertListToString(
    getRolesArray(roles).map(rolesItem => rolesItem.name),
    connector,
    lastConnector
  );
};

export const getRolesAsBadge = (roles = []) => {
  let rolesNames = getRolesArray(roles);
  return (
    <React.Fragment>
      {rolesNames.map(rolesName => (
        <Badge
          color={PROJECT_USER_ROLE_COLORS[rolesName.type]}
          size="extra_small"
        >
          {rolesName.name}
        </Badge>
      ))}
    </React.Fragment>
  );
};
